import { render, staticRenderFns } from "./ChanpinFenlei.vue?vue&type=template&id=4a95e77a&scoped=true&"
import script from "./ChanpinFenlei.vue?vue&type=script&lang=js&"
export * from "./ChanpinFenlei.vue?vue&type=script&lang=js&"
import style0 from "./ChanpinFenlei.vue?vue&type=style&index=0&id=4a95e77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95e77a",
  null
  
)

export default component.exports